(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-sellers"] && !Shopify.designMode) return;
  try {
    
  class MCTopSellers {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-track]');
      if (!this.track) return;
      this.buttons = root.querySelectorAll('[data-dir]');
      this.buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const dir = parseInt(btn.dataset.dir, 10);
          this.track.scrollBy({ left: this.track.clientWidth * 0.85 * dir, behavior: 'smooth' });
        });
      });
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.update();
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      this.buttons.forEach((btn) => {
        const dir = parseInt(btn.dataset.dir, 10);
        const atStart = this.track.scrollLeft <= 2;
        const atEnd = this.track.scrollLeft >= max;
        btn.disabled = (dir < 0 && atStart) || (dir > 0 && atEnd);
      });
    }
  }

  function initMCTopSellers() {
    document.querySelectorAll('.mc-topsellers').forEach((el) => {
      if (!el.__mcts) el.__mcts = new MCTopSellers(el);
    });
  }

  if (document.readyState !== 'loading') initMCTopSellers();
  document.addEventListener('DOMContentLoaded', initMCTopSellers);
  document.addEventListener('shopify:section:load', initMCTopSellers);

  } catch(e) { console.error(e); }
})();
})();
